module.exports = __webpack_public_path__ + "static/img/title.a12a419.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/title.png
// module id = Cb4U
// module chunks = 0